export default __webpack_public_path__ + "static/media/pit-crew-banner.dbec4d18.png";